(() => {
  const allowed = matchMedia('(pointer:fine) and (hover:hover) and (prefers-reduced-motion:no-preference)');
  let canvas, context, frame, particles = [], last = 0;
  const stop = () => { cancelAnimationFrame(frame); frame=0; particles=[]; canvas?.remove(); canvas=null; };
  const resize = () => { if (!canvas) return; const dpr=Math.min(devicePixelRatio||1,2); canvas.width=innerWidth*dpr; canvas.height=innerHeight*dpr; context.setTransform(dpr,0,0,dpr,0,0); };
  const draw = now => {
    context.clearRect(0,0,innerWidth,innerHeight);
    particles=particles.filter(p=>now-p.birth<1150);
    for(const p of particles) {
      const age=(now-p.birth)/1150, radius=3+age*23;
      const x=p.x+p.dx*age,y=p.y-38*age+p.dy*age;
      const g=context.createRadialGradient(x,y,0,x,y,radius);
      g.addColorStop(0,`rgba(196,139,150,${.3*(1-age)**2})`);g.addColorStop(.45,`rgba(231,187,198,${.14*(1-age)**2})`);g.addColorStop(1,'rgba(231,187,198,0)');
      context.fillStyle=g;context.beginPath();context.arc(x,y,radius,0,Math.PI*2);context.fill();
    }
    frame=particles.length?requestAnimationFrame(draw):0;
  };
  document.addEventListener('pointermove',event=>{
    if(!allowed.matches||document.hidden||event.pointerType==='touch') return;
    const now=performance.now();if(now-last<24) return;last=now;
    if(!canvas) {canvas=document.createElement('canvas');canvas.className='mist-canvas';canvas.setAttribute('aria-hidden','true');document.body.append(canvas);context=canvas.getContext('2d');if(!context){stop();return;}resize();}
    for(let i=0;i<4;i++) particles.push({x:event.clientX+(Math.random()-.5)*12,y:event.clientY,birth:now,dx:(Math.random()-.5)*38,dy:Math.random()*16});
    particles=particles.slice(-120);if(!frame) frame=requestAnimationFrame(draw);
  },{passive:true});
  addEventListener('resize',resize,{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
  allowed.addEventListener('change',()=>{if(!allowed.matches)stop();});
  addEventListener('pagehide',stop);
})();
